/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
/**
 * BlobDataApi - axios parameter creator
 * @export
 */
export const BlobDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get signed url for blob data, from the blob storage
         * @summary Download blob data
         * @param {string} blobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBlob: async (blobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blobId' is not null or undefined
            assertParamExists('downloadBlob', 'blobId', blobId)
            const localVarPath = `/api/v1/blob/{blobId}/download`
                .replace(`{${"blobId"}}`, encodeURIComponent(String(blobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BlobDataApi - functional programming interface
 * @export
 */
export const BlobDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BlobDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Get signed url for blob data, from the blob storage
         * @summary Download blob data
         * @param {string} blobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadBlob(blobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadBlob(blobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BlobDataApi.downloadBlob']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BlobDataApi - factory interface
 * @export
 */
export const BlobDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BlobDataApiFp(configuration)
    return {
        /**
         * Get signed url for blob data, from the blob storage
         * @summary Download blob data
         * @param {string} blobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadBlob(blobId: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.downloadBlob(blobId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BlobDataApi - interface
 * @export
 * @interface BlobDataApi
 */
export interface BlobDataApiInterface {
    /**
     * Get signed url for blob data, from the blob storage
     * @summary Download blob data
     * @param {string} blobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlobDataApiInterface
     */
    downloadBlob(blobId: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

}

/**
 * BlobDataApi - object-oriented interface
 * @export
 * @class BlobDataApi
 * @extends {BaseAPI}
 */
export class BlobDataApi extends BaseAPI implements BlobDataApiInterface {
    /**
     * Get signed url for blob data, from the blob storage
     * @summary Download blob data
     * @param {string} blobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BlobDataApi
     */
    public downloadBlob(blobId: string, options?: RawAxiosRequestConfig) {
        return BlobDataApiFp(this.configuration).downloadBlob(blobId, options).then((request) => request(this.axios, this.basePath));
    }
}

